<template>
  <div v-if="visible" class="payment-loader">
    <v-progress-circular
      indeterminate
      size="40"
      width="3"
      color="primary"
      class="slow-spinner"
    ></v-progress-circular>
    <div class="loader-text mt-3">{{ message }}</div>
  </div>
</template>

<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
    message: { type: String, default: 'Processing payment' }
  }
}
</script>

<style scoped>
.payment-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.loader-text {
  color: #333;
  font-weight: 500;
}

/* Ralentir l'animation du spinner */
.slow-spinner :deep(.v-progress-circular__indeterminate) {
  animation-duration: 2.5s !important; /* par défaut c'est environ 1.4s */
}
</style>
